'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { uniqueId } from 'lodash';
import { type ReactNode } from 'react';
import React from 'react';
import { type Spacing, getInnerSpacingClassNames, getOuterSpacingClassNames } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode[] | ReactNode;
  includedChildren?: any[];
  attributes?: any;
  innerSpacing?: Spacing;
  outerSpacing?: Spacing;
};
export const Container = t0 => {
  const $ = _c(30);
  let attributes;
  let builderBlock;
  let children;
  let containerProps;
  let includedChildren;
  let innerSpacing;
  let shouldRenderBuilderBlocks;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    const {
      className,
      children: t4,
      innerSpacing: t5,
      includedChildren: t6,
      outerSpacing,
      ...props
    } = t0;
    children = t4;
    innerSpacing = t5;
    includedChildren = t6;
    const {
      builderState,
      builderBlock: t7,
      attributes: t8,
      ...t9
    } = props as any;
    builderBlock = t7;
    attributes = t8;
    containerProps = t9;
    let t10;
    if ($[11] !== children) {
      t10 = () => !React.Children.count(children);
      $[11] = children;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    shouldRenderBuilderBlocks = t10;
    t1 = attributes;
    t2 = attributes?.key;
    t3 = cn("mx-auto w-full max-w-(--breakpoint-2xl) px-10 lg:px-32", getOuterSpacingClassNames(outerSpacing), className, attributes?.className);
    $[0] = t0;
    $[1] = attributes;
    $[2] = builderBlock;
    $[3] = children;
    $[4] = containerProps;
    $[5] = includedChildren;
    $[6] = innerSpacing;
    $[7] = shouldRenderBuilderBlocks;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    attributes = $[1];
    builderBlock = $[2];
    children = $[3];
    containerProps = $[4];
    includedChildren = $[5];
    innerSpacing = $[6];
    shouldRenderBuilderBlocks = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
  }
  const t4 = attributes?.style;
  let t5;
  if ($[13] !== innerSpacing) {
    t5 = cn("w-full", getInnerSpacingClassNames(innerSpacing));
    $[13] = innerSpacing;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== builderBlock?.id || $[16] !== children || $[17] !== includedChildren || $[18] !== shouldRenderBuilderBlocks) {
    t6 = shouldRenderBuilderBlocks() ? includedChildren?.map((child, index) => <BuilderBlocks key={uniqueId()} parentElementId={builderBlock?.id} dataPath={`component.options.includedChildren.${index}.item`} blocks={child.item} style={{
      minHeight: "200px"
    }} />) : children;
    $[15] = builderBlock?.id;
    $[16] = children;
    $[17] = includedChildren;
    $[18] = shouldRenderBuilderBlocks;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t5 || $[21] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== containerProps || $[24] !== t1 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4 || $[28] !== t7) {
    t8 = <div {...t1} key={t2} className={t3} style={t4} {...containerProps} suppressHydrationWarning={true}>{t7}</div>;
    $[23] = containerProps;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  return t8;
};